const namespace = {
  header: {
    title: "Explore {{neighborhood}}",
    description:
      "Learn about schools, prices, community vibe, and more before you decide to move.",
    titleNoNeighborhood: "the neighborhood",
  },
  cards: {
    neighborhoodIntel: {
      title: "Lifestyle Report",
      description: "",
    },
    neighborhoodContext: {
      title: "Neighborhood Context",
      description: "Discover what day to day life looks like in the area.",
    },
    locationInsights: {
      title: "Location Insights",
      description:
        "See how local amenities and features compare to the city average.",
    },
    climateRisk: {
      title: "Climate Risk",
      description:
        "Understand how climate risks may affect lifestyle and long-term value.",
    },
    communityPortrait: {
      title: "Community Portrait",
      description:
        "Explore demographics, housing types, and overall community vibe.",
    },
    localMarketOverview: {
      title: "Local Market Overview",
      description: "",
    },
    marketTrendsReport: {
      title: "Market Report",
      description: "",
    },
    neighborhoodMarketTrends: {
      title: "Neighborhood Market Trends",
      description: "",
    },
    dailyUpdates: {
      title: "Daily Updates",
      description: "",
    },
    fiveYearHistoricalView: {
      title: "5-Year Historical View",
      description: "",
    },
    easyToReadFormat: {
      title: "Easy-to-Read Format",
      description: "",
    },
    actionableInsights: {
      title: "Actionable Insights",
      description: "",
    },
  },
  downloadCard: {
    title: "Get your neighborhood report",
    description:
      "Uncover instant insights on local lifestyle, demographics, and market trends.",
    cta: "Get your report",
    ctaCAN: "Get your lifestyle report",
    select: {
      default: "Select report type",
      niReport: "Lifestyle Report",
      marketReport: "Market Report",
      both: "Both Reports",
    },
  },
  contactInfo: {
    back: "Back",
    title: "Almost there!",
    description:
      "Enter your details to get instant access to your neighborhood report. It’s fast, free, and full of insights.",
    submit: "Submit",
    confirmationMessage: "All set! We’ve sent your report to {{email}}",
    instructions:
      "Please check your inbox. If you don’t see it within a few minutes, check your spam or junk folder.",
    resendInstructions:
      "Still can’t find it? <resendReport>Click here to resend.</resendReport>",
    consentTexts: {
      topText:
        "I agree that Local Logic may share my contact information with real estate professionals so they can contact me regarding my home search.",
      bottomText:
        "This consent is required to use this tool. See our <LinkToPrivacyPolicy>Privacy Policy</LinkToPrivacyPolicy>.",
      // To be used in California and Canada
      CANTopText:
        "I agree that Local Logic may share my contact information with the operator of this website so they can contact me regarding my home search.",
      CANBottomText:
        "This consent is required to use this tool. You can withdraw your consent at any time. See our <LinkToPrivacyPolicy>Privacy Policy</LinkToPrivacyPolicy>.",
    },
  },
  initialValues: {
    firstName: "First Name *",
    lastName: "Last Name *",
    email: "Email Address *",
    phone: "Phone Number",
  },
  errors: {
    firstName: "First Name is required",
    lastName: "Last Name is required",
    email: "Email Address is required",
    notValidEmail: "Email Address is not valid",
    privacyCheckbox: "You must agree to the privacy policy",
    phone: "Phone is not a valid number",
  },
  toastAlerts: {
    error: {
      title: "Something went wrong",
      description:
        "We couldn’t complete your request. Please try again in a moment. If the issue continues, ",
      action: "contact support.",
    },
  },
} as const;

export default namespace;
